const translate = {
  table_title: {
    en: 'Set Availability for each branch(s)',
    es: 'Establecer Disponibilidad para cada Sucursal',
    fr: 'Définir la Disponibilité pour chaque Succursale',
    de: 'Verfügbarkeit für jede Filiale festlegen',
    pt: 'Definir Disponibilidade para cada Filial',
    pl: 'Ustaw Dostępność dla Każdego Oddziału',
    nl: 'Beschikbaarheid instellen voor elke vestiging',
    el: 'Ορισμός Διαθεσιμότητας για κάθε Υποκατάστημα',
    cs: 'Nastavit Dostupnost pro Každou Pobočku',
    sv: 'Ange Tillgänglighet för varje Filial',
    hu: 'Elérhetőség Beállítása Minden Fiókhoz',
    da: 'Indstil Tilgængelighed for hver Filial',
    fi: 'Aseta Saatavuus Jokaiselle Toimipisteelle',
    sk: 'Nastaviť Dostupnosť pre Každú Pobočku',
    bg: 'Задаване на Наличност за Всеки Клон',
    hr: 'Postavi Dostupnost za Svaku Podružnicu',
    lt: 'Nustatyti Prieinamumą Kiekvienai Filialui',
    lv: 'Iestatīt Pieejamību Katrai Filiālei',
    et: 'Määra Saadavus Iga Filiaali Jaoks',
    ga: 'Socraigh Infhaighteacht do gach Brainse',
    mt: 'Issettja Disponibbiltà għal Kull Fergħa',
    cy: 'Gosod Argaeledd ar gyfer Pob Cangen',
    ro: 'Setează Disponibilitatea pentru Fiecare Filială',
    it: 'Imposta la Disponibilità per Ogni Filiale',
    zh_cn: '为每个分店设置可用性',
    hi: 'प्रत्येक शाखा के लिए उपलब्धता सेट करें',
    ar: 'تعيين التوفر لكل فرع',
    bn: 'প্রত্যেক শাখার জন্য প্রাপ্যতা নির্ধারণ করুন',
    ru: 'Установить Доступность для Каждого Филиала',
    ja: '各支店の利用可能時間を設定する',
    tr: 'Her Şube için Kullanılabilirliği Ayarla',
    ko: '각 지점의 이용 가능 여부 설정',
    vi: 'Đặt Tình Trạng Có Sẵn Cho Mỗi Chi Nhánh',
    id: 'Tetapkan Ketersediaan untuk Setiap Cabang',
    th: 'ตั้งค่าความพร้อมใช้งานสำหรับแต่ละสาขา',
    ms: 'Tetapkan Ketersediaan untuk Setiap Cawangan',
    ar_eg: 'تعيين التوفر لكل فرع',
    uk: 'Встановити Доступність для Кожної Філії',
  },
  availability_time: {
    en: 'Availability Time',
    es: 'Horario de Disponibilidad',
    fr: 'Heure de Disponibilité',
    de: 'Verfügbarkeitszeit',
    pt: 'Horário de Disponibilidade',
    pl: 'Czas Dostępności',
    nl: 'Beschikbaarheidsperiode',
    el: 'Χρόνος Διαθεσιμότητας',
    cs: 'Doba Dostupnosti',
    sv: 'Tillgänglighetstid',
    hu: 'Elérhetőségi Idő',
    da: 'Tilgængelighedstid',
    fi: 'Saatavuusaika',
    sk: 'Čas Dostupnosti',
    bg: 'Време на Наличност',
    hr: 'Vrijeme Dostupnosti',
    lt: 'Prieinamumo Laikas',
    lv: 'Pieejamības Laiks',
    et: 'Saadavuse Aeg',
    ga: 'Am Infhaighteachta',
    mt: 'Ħin ta’ Disponibbiltà',
    cy: 'Am Argaeledd',
    ro: 'Timp de Disponibilitate',
    it: 'Orario di Disponibilità',
    zh_cn: '可用时间',
    hi: 'उपलब्धता समय',
    ar: 'وقت التوفر',
    bn: 'প্রাপ্যতার সময়',
    ru: 'Время Доступности',
    ja: '利用可能時間',
    tr: 'Kullanılabilirlik Süresi',
    ko: '이용 가능 시간',
    vi: 'Thời Gian Có Sẵn',
    id: 'Waktu Ketersediaan',
    th: 'เวลาที่พร้อมใช้งาน',
    ms: 'Masa Ketersediaan',
    ar_eg: 'وقت التوفر',
    uk: 'Час Доступності',
  },
  select_availability: {
    en: 'Select Availability',
    es: 'Seleccionar Disponibilidad',
    fr: 'Sélectionner la Disponibilité',
    de: 'Verfügbarkeit Auswählen',
    pt: 'Selecionar Disponibilidade',
    pl: 'Wybierz Dostępność',
    nl: 'Beschikbaarheid Selecteren',
    el: 'Επιλέξτε Διαθεσιμότητα',
    cs: 'Vybrat Dostupnost',
    sv: 'Välj Tillgänglighet',
    hu: 'Elérhetőség Kiválasztása',
    da: 'Vælg Tilgængelighed',
    fi: 'Valitse Saatavuus',
    sk: 'Vybrať Dostupnosť',
    bg: 'Изберете Наличност',
    hr: 'Odaberite Raspoloživost',
    lt: 'Pasirinkite Prieinamumą',
    lv: 'Izvēlēties Pieejamību',
    et: 'Vali Saadavus',
    sl: 'Izberite Razpoložljivost',
    ga: 'Roghnaigh Infhaighteacht',
    mt: 'Agħżel id-Disponibbiltà',
    cy: 'Dewiswch Argaeledd',
    ro: 'Selectați Disponibilitatea',
    it: 'Seleziona Disponibilità',
    zh_cn: '选择可用性',
    hi: 'उपलब्धता चुनें',
    ar: 'اختر التوفر',
    bn: 'উপলব্ধতা নির্বাচন করুন',
    ru: 'Выбрать Наличие',
    ja: '利用可能性を選択',
    tr: 'Kullanılabilirliği Seç',
    ko: '가용성 선택',
    vi: 'Chọn Tính Sẵn Có',
    id: 'Pilih Ketersediaan',
    th: 'เลือกความพร้อมใช้งาน',
    ms: 'Pilih Ketersediaan',
    ar_eg: 'اختر الإتاحة',
    uk: 'Вибрати Наявність',
  },
}

export default translate
